<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <safety-forms-summary-report-table></safety-forms-summary-report-table>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import SafetyFormsSummaryReportTable from '../components/safety/safetyFormsSummaryReportTable.vue';
import routes from '../../../routes.js';

export default {
  page: {
    title: 'manageSafetyForms',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    SafetyFormsSummaryReportTable,
  },
  data() {
    return {
      title: 'Safety Forms Summary Report',
      name: 'safetyFormsSummaryReport',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'safety forms summary report',
          href: '/production/safety/safetyFormsSummaryReport',
          active: true,
        },
      ],
      routes: routes,
    };
  },
};
</script>
